<template>
    <bubble-msg @chooseItem="chooseItem"
        @loadMore="loadMore" v-if="templateId === 4 || templateId === 1"
        :message="message"
        :isShowLoading="isShowLoading"></bubble-msg>
    <card-msg @chooseItem="chooseItem"
        @loadMore="loadMore" v-else-if="templateId === 3"
        :message="message"
        :isShowLoading="isShowLoading"></card-msg>
</template>
<script>
import BubbleMsg from './reverso-sub-msg/BubbleMsg';
import CardMsg from './reverso-sub-msg/CardMsg';
import transfer from '@/utils/xmlMsg/robotCardXml';
import globalWin from '@/utils/globalWin';
import ajaxGetGoodsList from './fetchGoodsList';
export default {
  components: {
    BubbleMsg,
    CardMsg,
  },
  inject: ['to', 'wpaDetail', 'switchMsgDisplay'],
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    templateId() {
      return this.message?.content?.content?.templateId;
    },
  },
  data() {
    return {
      isShowLoading: false,
    };
  },
  methods: {
    async loadMore(options = {}) {
      const { content: { content: { contentData: { currentPage }, questionId = '', domain = '', intent = '', tabId, pageSize } } } = this.message;
      // eslint-disable-next-line camelcase, no-unused-vars
      const { crm: { msg_webim_extra_data: { bytes_wpaid = '', uint64_robotid = '' }, str_session_id } } = this.message;
      const params = {
        questionId,
        domain,
        intent,
        tabId,
        pageSize,
        currentPage: currentPage + 1, // 传下一页
        robotId: uint64_robotid,
        sessionId: str_session_id,
        wpaId: bytes_wpaid,
        corpUin: this.wpaDetail.kfuin,
        visitId: this.to.user_id,
        channelType: 3,
      };
      this.isShowLoading = true;
      const response = await ajaxGetGoodsList(params);
      this.isShowLoading = false;
      const { code, msg, data } = response;
      if (+code === 0) {
        try {
          if (!data.contentData) {
            this.$Toast('暂无更多订单');
            this.message.content.content.contentData.hasNext = false;
            return;
          }
          const { contentData: { contentList = [], hasNext, currentPage } } = data;
          const newContentList = this.message.content.content.contentData.contentList.concat(contentList);
          this.message.content.content.contentData.hasNext = hasNext;
          this.message.content.content.contentData.currentPage = currentPage;
          this.$set(this.message.content.content.contentData, 'contentList', newContentList);
          if (options.type === 'bubble') {
            this.$nextTick(() => {
              globalWin.scrollToBottom();
            });
          }
        } catch {
          this.$Toast('更多数据加载失败');
        }
      } else {
        this.$Toast(msg || '更多数据加载失败');
      }
    },
    chooseItem(item) {
      this.openPop = false;
      this.switchMsgDisplay(this.message.seq, 'delete');
      globalWin.sendQDXMLMessage({
        qdxml: {
          content: transfer(item),
        },
      }, null, {
        robot_ctrl: {
          str_ext2robot: JSON.stringify({ ...item, extRobotType: 2 }),
        },
      });
    },
  },
};
</script>
